import { useEffect, useState } from 'react';
import { authApi } from '../services/api';

interface AssignedMentor {
  name: string;
  email?: string | null;
  phone?: string | null;
  backgroundBrief?: string | null;
}

export default function AboutYourMentorBlock() {
  const [mentor, setMentor] = useState<AssignedMentor | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    authApi.getAssignedMentor()
      .then((data) => {
        setMentor(data.mentor ?? null);
      })
      .catch(() => {
        setMentor(null);
      })
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || !mentor?.backgroundBrief) return null;

  return (
    <section className="living-room-asset-block" aria-label="About Your Mentor">
      <h2 className="living-room-asset-title">About Your Mentor</h2>
      <p className="living-room-asset-mentor-name">{mentor.name}</p>
      <p className="living-room-asset-brief">{mentor.backgroundBrief}</p>
    </section>
  );
}
